import type { UIMatch } from 'react-router';

import { cmsRouteId } from './Cms.horizon-route';
import type { CmsPageLoaderData } from './CmsPageLoaderData';

export function isSearchLandingPageSSRMatch(
  match: UIMatch,
): match is UIMatch<
  Extract<CmsPageLoaderData, { type: 'SEARCH_LANDING_PAGE' }>
> {
  if (match.id !== cmsRouteId) return false;

  const data = match.data as CmsPageLoaderData;
  if (!data) return false;

  return data.type === 'SEARCH_LANDING_PAGE' && Boolean(data.ssr);
}
